/* ============================================================
   FIXED VERSION
   Changes from the original are called out in comments below.
   ============================================================ */

// FIX: wrap ALL DOM-dependent code in one DOMContentLoaded/load
// handler instead of only wrapping the read-more block. This
// guarantees every selector below runs only after the elements
// exist in the page, no matter where the <script> tag sits.
document.addEventListener('DOMContentLoaded', function () {

  // ---------- Read more / read less ----------
  $(".readmore").on('click', function () {
    $(".test2").show();
    $(".readmore").hide();
    $(".readless").show();
  });

  $(".readless").on('click', function () {
    $(".test2").hide();
    $(".readmore").show();
    $(".readless").hide();
  });

  // ---------- FAQ accordion tabs ----------
  var tab = document.querySelectorAll(".tab");
  tab.forEach(function (ques) {
    var btn = ques.querySelector(".faq-tab-toggle");

    // FIX: guard against a .tab that has no .faq-tab-toggle child.
    // Without this check, addEventListener on null throws and
    // stops every script below it from running.
    if (!btn) return;

    btn.addEventListener("click", function () {
      tab.forEach(function (closed) {
        if (closed !== ques) {
          closed.classList.remove("show-item");
        }
      });
      ques.classList.toggle("show-item");
    });
  });

  // ---------- "Add more items" button ----------
  var element = document.querySelector(".btnmore");
  var id = 0;

  if (element) {
    element.addEventListener("click", myFunction);
  }

  function myFunction() {
    if (id < 6) {
      id = id + 1;
      var Element = document.querySelector(".item_container_add");
      if (!Element) return;

      // FIX: use a class instead of a repeated id="dropdown"/id="quant"
      // (duplicate IDs are invalid HTML and break getElementById/#id
      // lookups elsewhere on the page).
      //
      // FIX: label "for" now matches the actual <select> id
      // (user_requirement-${id} / user_quantity-${id}) instead of
      // pointing at a non-existent "Item-${id}" / "Quantity-${id}".
      Element.insertAdjacentHTML('beforeend', `<div class="form-fields-columns">
        <div class="form-field form-field--half dropdown-field">
          <label for="user_requirement-${id}" class="form-field-title">What do you require?</label>
          <select id="user_requirement-${id}" name="contact[Item-${id}]" class="form-field-input form-field-text">
            <option></option>
            <option>Chairs</option>
            <option>Desks</option>
            <option>Stroage</option>
            <option>Lockers</option>
            <option>Accessories</option>
            <option>All of the Above</option>
            <option>Other</option>
          </select>
        </div>
        <div class="form-field form-field--half quant-field">
          <label for="user_quantity-${id}" class="form-field-title">Quantity</label>
          <select id="user_quantity-${id}" name="contact[Quantity-${id}]" class="form-field-input form-field-text">
            <option>1</option>
            <option>2</option>
            <option>3</option>
            <option>4</option>
            <option>5</option>
            <option>6+</option>
          </select>
        </div>
      </div>`);
      // NOTE: switched .innerHTML += ... to insertAdjacentHTML('beforeend', ...).
      // innerHTML += re-parses and rebuilds every existing child each time,
      // which discards any state/listeners already attached to them.
      // insertAdjacentHTML only parses and appends the new chunk.
    }
  }

  // ---------- 4-installment price ----------
  $(".options-selection__input-select-wrapper").on('change', function () {
    var priceEl = $('.product-pricing .price__current .money');

    // FIX: bail out instead of throwing if the price element isn't
    // on the page (priceEl.html() would otherwise be undefined and
    // .replace() on it would throw).
    if (!priceEl.length) return;

    var cust_price = Number(priceEl.html().replace(/[^0-9.-]+/g, ""));
    if (isNaN(cust_price)) return;

    // FIX: round to 2 decimal places instead of a raw float division
    // (avoids "$41.666666666666664").
    var install_price = "$" + (cust_price / 4).toFixed(2);
    $(".payment-4-installment p b .h2").html(install_price);
  });

  // ---------- Metafield tabs ----------
  window.openTab = function (evt, tabName) {
    var tabContent = document.getElementsByClassName("meta-tab");
    for (var i = 0; i < tabContent.length; i++) {
      tabContent[i].style.display = "none";
    }

    var tabLinks = document.getElementsByClassName("tab-link");
    for (var i = 0; i < tabLinks.length; i++) {
      tabLinks[i].classList.remove("active");
    }

    var target = document.getElementById(tabName);
    if (target) target.style.display = "block";
    if (evt && evt.currentTarget) evt.currentTarget.classList.add("active");
  };

  var defaultTab = document.querySelector(".tab-link.active");
  var firstTab = document.querySelector(".tab-link");

  if (defaultTab) {
    defaultTab.click();
  } else if (firstTab) {
    firstTab.click();
  }
});

// Faq section for blog
 
document.addEventListener("DOMContentLoaded", () => {
  const articleContent = document.querySelector(".article--content");
  if (!articleContent) return;
 
  let html = articleContent.innerHTML;
 
  /* ---------- CHECK FAQ ---------- */
  if (!html.includes("<!-- FAQ -->")) return;
 
  const parts = html.split("<!-- FAQ -->");
  const contentHTML = parts[0];
  const faqRaw = parts[1];
 
  let faqHTML = "";
 
  const faqItems = faqRaw
    .split("@@@")
    .map(item => item.trim())
    .filter(Boolean);
 
  if (faqItems.length) {
    faqHTML = `
      <div class="blog-faq">
        <h2>FAQs</h2>
        ${faqItems.map(item => {
          // FIX: only split on the FIRST "|||". The previous
          // item.split("|||") with no limit silently dropped any
          // extra text if the answer itself ever contained "|||".
          const sepIndex = item.indexOf("|||");
          if (sepIndex === -1) return "";
 
          const q = item.slice(0, sepIndex);
          const a = item.slice(sepIndex + 3);
          if (!q.trim() || !a.trim()) return "";
 
          // Strip stray <p> wrappers from BOTH question and answer.
          // FIX: previously only `q` was cleaned; if the answer came
          // from a rich text field already wrapped in <p>...</p>,
          // re-wrapping it below produced invalid nested <p><p></p></p>.
          const cleanQ = q.replace(/<\/?p[^>]*>/gi, "").trim();
          const cleanA = a.replace(/<\/?p[^>]*>/gi, "").trim();
 
          return `
            <div class="faq-item">
              <div class="faq-question" role="button" aria-expanded="false">
                <h5 class="faq-text">${cleanQ}</h5>
                <span class="faq-icon"></span>
              </div>
              <div class="faq-answer">
                <p>${cleanA}</p>
              </div>
            </div>
          `;
        }).join("")}
      </div>
    `;
  }
 
  /* ---------- RENDER ---------- */
  articleContent.innerHTML = contentHTML + faqHTML;
 
  /* ---------- ACCORDION ---------- */
  const wrapper = articleContent.querySelector(".blog-faq");
  if (!wrapper) return; // safety fix
 
  wrapper.addEventListener("click", (e) => {
    const question = e.target.closest(".faq-question");
    if (!question) return;
 
    const item = question.closest(".faq-item");
    const isActive = item.classList.contains("active");
 
    // Close all
    wrapper.querySelectorAll(".faq-item").forEach(el => {
      el.classList.remove("active");
      el.querySelector(".faq-question")
        ?.setAttribute("aria-expanded", "false");
    });
 
    // Open clicked
    if (!isActive) {
      item.classList.add("active");
      question.setAttribute("aria-expanded", "true");
    }
  });
});